'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineAction = require('./defineAction');

Object.defineProperty(exports, 'defineAction', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_defineAction).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/redux-define/lib/index.js
// module id = 16
// module chunks = 0